import React from 'react';
import PropTypes from 'prop-types';
import loader from './loader.svg';

const BigPreLoader = props => (
  <div className={props.classes}>
    <div>
      <div className="loader loader-big">
        <div className="loader-icon spinning-cog">
          <img src={loader} alt="Загрузка" />
        </div>
      </div>
    </div>
  </div>
);

BigPreLoader.defaultProps = {
  classes: ''
};

BigPreLoader.propTypes = {
  classes: PropTypes.string
};

export default BigPreLoader;



// WEBPACK FOOTER //
// ./src/components/Common/PreLoaders/BigPreLoader.js